import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useSelector} from "react-redux";
import TablePageContext from "../../../Context/TablePageContext";
import LinearProgress from '@mui/material/LinearProgress';
import ProjectCategoryForm from "../../../Components/Forms/Pages/Project/ProjectCategory/ProjectCategoryForm";
import { editProjectCategory, getAllProjectCategories} from "../../../Services/Project/ProjectCategoryService";
import SnackbarContext from "../../../Context/SnackbarContext";
import { filterDropdownItem } from "../../../Util/DropdownUtil";

const formRules = {
    'name': {required: true}
}

const EditProjectCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.project.projectCategory.editProjectCategory.pageTitle);
    });

    useEffect(() => {
        fetch(); 
    },[])

    const fetch = () => {
        getAllProjectCategories().then(response => {
            if (!response || !response.ok) {
                return;
            }

            setParents(filterDropdownItem(response.data, props.data[0]?.id));
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editProjectCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProjectCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditProjectCategory;